import { User } from '../types/User';
import { toCamelCase } from '../utils/caseConverter';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchUsers = () => {
  return fetch(`${API_BASE_URL}/api/users`, {
      headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`},
    }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function fetchUserById(id: string): Promise<User> {
  const users: User[] = await fetchUsers();
  const user = users.find(u => String(u.id) === String(id));
  if (!user) throw new Error('User not found');
  return user;
}

